import { useServices } from 'core/services';
import { tokenKeys } from 'core/utils/query-key-factory';
import { useQuery } from '@tanstack/react-query';

export const useGetTransferRequestToken = (
	communityId: string,
	tokenId: string,
	options: { enabled: boolean } = { enabled: true }
) => {
	const { api } = useServices();

	return useQuery({
		queryKey: tokenKeys.transferRequest(communityId, tokenId),
		queryFn: () =>
			api
				.getTransferRequestToken(communityId, tokenId)
				.then(response => response.data),
		enabled: !!communityId && !!tokenId && options.enabled,
		refetchOnMount: true,
		staleTime: 10000, // 10 seconds
	});
};
